import { render, staticRenderFns } from "./BirthdayStatisticsV3.vue?vue&type=template&id=4dde6998&scoped=true"
import script from "./BirthdayStatisticsV3.vue?vue&type=script&lang=js"
export * from "./BirthdayStatisticsV3.vue?vue&type=script&lang=js"
import style0 from "./BirthdayStatisticsV3.vue?vue&type=style&index=0&id=4dde6998&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dde6998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dde6998')) {
      api.createRecord('4dde6998', component.options)
    } else {
      api.reload('4dde6998', component.options)
    }
    module.hot.accept("./BirthdayStatisticsV3.vue?vue&type=template&id=4dde6998&scoped=true", function () {
      api.rerender('4dde6998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/v3/BirthdayStatisticsV3.vue"
export default component.exports